<template>
    <v-tooltip :bottom="bottom" :top="top" :left="left" :right="right" class="tipp">
        <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information</v-icon>
        </template>
        <div class="max-width-tipp">{{ text }}</div>
    </v-tooltip>
</template>

<script>
export default {
    name: 'Tipp',
    props: ['position', 'text'],
    computed: {
        top() {
            return this.position === 'top';
        },
        bottom() {
            return this.position === 'bottom';
        },
        left() {
            return this.position === 'left';
        },
        right() {
            return this.position === 'right';
        },
    },
};
</script>

<style lang="scss" scoped></style>
